var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_14079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2.11115C6.47 2.11115 2 5.99855 2 10.7884C2 15.5782 6.47 19.4656 11.99 19.4656C17.52 19.4656 22 15.5782 22 10.7884C22 5.99855 17.52 2.11115 11.99 2.11115ZM12 17.7302C7.58 17.7302 4 14.6237 4 10.7884C4 6.95305 7.58 3.8466 12 3.8466C16.42 3.8466 20 6.95305 20 10.7884C20 14.6237 16.42 17.7302 12 17.7302Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.44977H11V11.6561L16.25 14.3895L17 13.3221L12.5 11.0053V6.44977Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_14079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.8254,
    fill: "white",
    transform: "translate(0 0.375671)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c9d5dded.svg";
export { ForwardRef as ReactComponent };